import {Component, OnInit} from '@angular/core';
import {UntypedFormGroup, Validators, FormControl} from '@angular/forms';
import {ProviderService} from 'src/app/shared/services/provider.service';
import {Router, ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm = new UntypedFormGroup({
    login: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });

  submitted = false;
  errorMessage = '';
  refreshToken: string;
  loader = false;

  constructor(
    private service: ProviderService,
    private router: Router,
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    localStorage.removeItem('PortalTokenManager');
    this.route.queryParams.subscribe(params => {
      if (params.secret) {
        this.refreshToken = params.secret;
        this.authWithRefreshToken();
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      this.errorMessage = '';
      return;
    } else {
      this.getResult('login');
    }
  }

  authWithRefreshToken() {
    this.getResult('token');
  }

  getResult(type: 'login' | 'token') {
    let service: any;
    if (type === 'login') {
      service = this.service.login(this.loginForm.get('login')?.value, this.loginForm.get('password')?.value);
    } else if (type === 'token') {
      service = this.service.getTokenWithRefreshToken(this.refreshToken);
    }

    this.loader = true;
    service.subscribe(res => {
      this.loader = false;
      localStorage.setItem('PortalLoginManager', res.userName);
      const roles = res.rolesName.split(', ');
      const ind = roles.findIndex(r => r === 'PortalManager');
      if (ind !== -1) {
        localStorage.setItem('PortalTokenManager', res.access_token);
        return this.router.navigate(['/main/users/list']);
      }
      if (ind === -1) {
        this.errorMessage = 'У вас нет доступа к сайту! Обратитесь к администратору!';
        return this.router.navigate(['login']);
      }
    }, (err) => {
      this.loader = false;
      this.errorMessage = err.error.error_description;
    });
  }

}
